<template>
    <div class="button-set">
        <round-btn
            v-if="!noShare"
            shadow-color="rgba(171, 203, 216, 0.5)"
            background-color="#35b0ef"
            color="#ffffff"
            font-size="1.5em"
            height="60px"
            @click="onShare"
        >
            <div class="button-content">
                <img
                    src="@/assets/Stage/Result/share.png"
                    alt=""
                    class="icon"
                />
                <div class="text">分享給朋友</div>
            </div>
        </round-btn>
        <round-btn
            shadow-color="rgba(171, 203, 216, 0.5)"
            background-color="#5ac892"
            color="#ffffff"
            font-size="1.5em"
            height="60px"
            @click="$router.go(-1)"
        >
            <div class="button-content">
                <img
                    src="@/assets/Stage/Result/again.png"
                    alt=""
                    class="icon"
                />
                <div class="text">再玩一次</div>
            </div>
        </round-btn>
        <round-btn
            shadow-color="rgba(201, 158, 0, 0.37)"
            background-color="#e9bb5d"
            color="#ffffff"
            font-size="1.5em"
            height="60px"
            @click="$router.push({ name: 'Stage_Review' })"
        >
            <div class="button-content">
                <img
                    src="@/assets/Stage/Result/review.png"
                    alt=""
                    class="icon"
                />
                <div class="text">作答回顧</div>
            </div>
        </round-btn>
        <round-btn
            shadow-color="rgba(171, 203, 216, 0.5)"
            background-color="#5678e6"
            color="#ffffff"
            font-size="1.5em"
            height="60px"
            @click="$router.go(-2)"
        >
            <div class="button-content">
                <img src="@/assets/Stage/Result/back.png" alt="" class="icon" />
                <div class="text">返回關卡</div>
            </div>
        </round-btn>
    </div>
</template>

<script>
export default {
    props: {
        noShare: Boolean,
    },
    computed: {
        encodeURI() {
            return encodeURIComponent(window.origin);
        },
        shareUrl() {
            return `https://line.me/R/msg/text/?${this.encodeURI}`;
        },
    },
    methods: {
        onShare() {
            window.open(this.shareUrl);
        },
    },
};
</script>

<style lang="scss" scoped>
.button-set {
    padding: 20px 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    > * {
        margin-bottom: 2vh;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .button-content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        .icon {
            margin: 0 10px;
            width: 30px;
        }
        .text {
            width: 125px;
        }
    }
}
</style>
